<template lang="pug">
  div
    template(v-if="isDesktop")

      h1.HorizontalScrollView_title(ref="title", v-html="title")

      HorizontalScrollList
        swiper-slide(v-for="(item, index) in pages", :key="item.id", v-if="item._data.attributes.promote == true")
          PageListItem(:index="index",
          :item="item",
          @mouseover.native="onOverHandler(index)",
          @mouseleave.native="onLeaveHandler(index)")

    template(v-else)

      h1.HorizontalScrollView_title_mobile(ref="title", v-html="title")

      .VerticalScrollList
       PageListItem(v-for="(item, index) in pages", :key="item.id" :index="index", :item="item", v-if="item._data.attributes.promote == true")

</template>

<script>

import Vue from 'vue'
import PageModel from '@/models/PageModel'
import PageListItem from '@/components/PageListItem'
import HorizontalScrollList from '@/components/common/HorizontalScrollList'
import i18n from '@/i18n'

export default {
  name: 'page-list',
  components: {
    PageListItem,
    HorizontalScrollList
  },
  data () {
    return {
      pages: null,
      isDesktop: null,
      isOver: false,
      isOverIndex: 0,
      indexItem: 0,
      title: null
    }
  },
  metaInfo () {
    // Override title by menu item title.
    return { title: this.$t('meta.title.pages').replace('page_title', this.title) }
  },
  mounted () {
    this.title = this.$attrs.title
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)

    let elements = this.$el.querySelectorAll('.ListItem')
    for (let i = 0; i < elements.length; i++) {
      this.$parallax.remove(elements[i])
    }
  },
  beforeRouteEnter (to, from, next) {
    Promise.all([
      Vue.$api.getPages(i18n.locale),
      Vue.$api.getMenu(i18n.locale)
    ])
      .then(([pagesResponse, menuResponse]) => {
        next(vm => {
          vm.setData(pagesResponse.data, menuResponse.data)
        });
      })
      .catch(error => {
        console.error('Error fetching data:', error)
        next()
      })
  },
  methods: {
    onOverHandler (index) {
      this.isOver = true
      this.isOverIndex = index
    },
    onLeaveHandler (index) {
      this.isOver = false
    },
    setData (data, title) {
      // Override title by menu item title.
      let item = title.main.filter(item => item.url.slice(-6) === '/pages').shift()
      if (item) {
        this.title = item.title
      }
      // Limited pages by promote.
      this.pages = data.data.filter(p => p.attributes.promote == true).map((c) => {
        this.$nextTick(() => {
          this.onResize()
        })
        return new PageModel(c, data.included)
      })
    },
    onResize () {
      if (window.innerWidth < 768) {
        this.isDesktop = false
        let elements = this.$el.querySelectorAll('.ListItem')
        for (let i = 0; i < elements.length; i++) {
          this.$parallax.set(elements[i], { y: 0, opacity: 1 }, { y: 60, opacity: 0.1 }, { y: 0, opacity: 1 }, null, 0.5)
        }
      } else {
        this.isDesktop = true
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .swiper-slide
    box-sizing border-box
    width 'calc(100vw - 40px - %s)' % $menu_bar_width_mobile
    max-width: 400px

    @media $mq_m
      width 'calc(100vw - 80px - %s)' % $menu_bar_width

    & + .swiper-slide
      margin-left 40px

  .HorizontalScrollView_bgTile-hover {
    page_horizontal_gutter = 8vw;
    position: relative;
    overflow: hidden;
    content: '';
    position: absolute;
    width: 200%;
    height: 400%;
    top: 50%;
    left: 50%;
    transform-origin: 0 50%;
    transform: translate(0, -50%) rotateZ(45deg);
    background-size: cover;
    overflow: hidden;
  }

  .HorizontalScrollView_bgTile-hover_img {
    position: fixed;
    display: block;
    width: 50%;
    height: 25%;
    top: 25%;
    left: 0;
    -webkit-transform: rotateZ(-45deg);
    transform: translate(-50%, 50%) rotateZ(-45deg);
    background-position: 50% 50%;
    background-size: cover;
    opacity: 0;
    transition: All 0.4s ease;
  }

  .visible {
    opacity: 0.4;
  }
</style>
